/* ============================================================================
   ARPIVIA - C1-B - Ordre de la zone de reassurance
   ----------------------------------------------------------------------------
   La garantie est rendue a l'interieur du bloc offre, en fin de `.c1b-actions`.
   Le bloc livraison, lui, est un bloc de gabarit rendu APRES l'offre. Dans le
   DOM, la garantie precede donc la livraison, alors que le cahier demande
   l'inverse : livraison, puis garantie, puis paiement.

   `order` ne peut pas les croiser : les deux elements n'ont pas le meme parent,
   et la garantie est imbriquee de deux niveaux dans l'offre. On deplace donc le
   noeud existant, une seule fois, sans le recreer. Le titre, l'explication, le
   lien et ses conditions restent exactement ceux que rend le bloc offre : il n'y
   a pas de seconde copie du texte a maintenir.

   Le deplacement a lieu avant que l'offre ne se declare prete
   (`data-ready`), moment ou `.c1b-actions` cesse d'etre masque : rien ne
   clignote, la garantie n'est jamais peinte a l'ancienne place.

   Le script est idempotent : rappele apres un rechargement de section dans
   l'editeur de theme, il ne fait rien si l'ordre est deja bon.
   ========================================================================== */

(function () {
  function placer() {
    var details = document.querySelector('.product-details');
    if (!details) return;

    var garantie = details.querySelector('.c1b-guarantee, .c1b-reassure');
    var livraison = details.querySelector('.arpivia-c1b-livraison');

    /* Sans l'un des deux, on ne touche a rien : l'ordre rendu par le serveur
       reste valide, il est simplement moins bon. */
    if (!garantie || !livraison) return;
    if (livraison.nextElementSibling === garantie) return;

    livraison.after(garantie);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', placer, { once: true });
  } else {
    placer();
  }

  document.addEventListener('shopify:section:load', placer);
})();
